module.exports = __webpack_public_path__ + "img/craneRearRightOutline.ae56fbce.svg";